<template lang="pug">
    b-container.page-container
      h1 Payment failed
      p Please try again in a sec
      router-link(:to="{name: 'orderPage'}")
        i.fa.fa-caret-left.mr-2
        span try again
</template>

<script>
export default {
  name: 'PaymentFailed',
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/PaymentFailed.vue